// src/lib/supabaseClient.ts
import { createClient, SupabaseClient } from '@supabase/supabase-js';

// Busca as variáveis de ambiente usando import.meta.env e o prefixo VITE_
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error("Supabase URL não encontrada. Verifique suas variáveis de ambiente e se estão prefixadas com VITE_ (ex: VITE_SUPABASE_URL).");
}

if (!supabaseAnonKey) {
  throw new Error("Supabase Anon Key não encontrada. Verifique suas variáveis de ambiente e se estão prefixadas com VITE_ (ex: VITE_SUPABASE_ANON_KEY).");
}

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey);

console.log("Supabase client inicializado com Vite env vars.");
